import React from 'react';
import './styles/ModalForms.css';

// Função auxiliar para definir o tipo com base na mensagem
function getModalTypeFromMessage(message = '') {
  const msg = typeof message === 'string' ? message.toLowerCase() : '';
  if (msg.includes('sucesso') || msg.includes('criado') || msg.includes('atualizado')) return 'success';
  if (msg.includes('erro') || msg.includes('falha') || msg.includes('não foi possível')) return 'error';
  if (msg.includes('tem certeza') || msg.includes('deseja remover')) return 'warning';
  return 'info';
}

function ModalForms({ message, onConfirm, onCancel, isDeleting, showButtons = true, type }) {
  const resolvedType = type || getModalTypeFromMessage(message);
  return (
    <div className="multiModal">
      <div className="modal-overlay">
        <div className={`modal-content ${resolvedType}`}>
          {typeof message === 'string' ? <p>{message}</p> : message}
          {showButtons && (
            <div className="modalButtons">
              <button className='modalBtn' onClick={onConfirm} disabled={isDeleting}>
                {isDeleting ? 'Deletando...' : 'Sim'}
              </button>
              {!isDeleting && (
                <button className='modalBtnCancel' onClick={onCancel}>
                  Não
                </button>
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ModalForms;
